var toNumber = {};
export {
  toNumber as __exports
};
//# sourceMappingURL=toNumber.js.map
